import {
  setAVSessionID,
  removeAVSessionID,
  tempCacheStorage,
} from 'src/boot/axios'
import {
  ageRestrictedBrowsingPages,
  ageRestrictedNonBrowsingPages,
  appConfig,
} from 'src/constants'
import { isDateEqual } from 'src/utils'
import { useAgeVerificationStore } from 'src/stores/age-verification'
import { useCustomerStore } from 'src/stores/customer'
import { useAuthStore } from 'src/stores/auth'
import { usePersistedStore } from 'src/stores/persisted'
import { mapState } from 'pinia'
import {
  instanceLoaded,
  verificationDuring,
  ftxIdentityLiteInstance,
} from './identity-mixin-shared-state'

var FTXIdentityLite = null

// var headerHeight = 0

export default {
  data() {
    return {
      interval: null,
      ageVerificationStore: useAgeVerificationStore(),
      customerStore: useCustomerStore(),
      authStore: useAuthStore(),
      persistedStore: usePersistedStore(),
      identityInstanceInitialized: false,
      headerHeight: 0,
    }
  },
  computed: {
    ...mapState(usePersistedStore, ['showEAIVPage']),
    getHeaderHeight() {
      return this.headerHeight
    },
    ageRestrictedPages() {
      return [...ageRestrictedBrowsingPages, ...ageRestrictedNonBrowsingPages]
    },
    getEAIVExternalURL() {
      return appConfig.EAIV_ExternalURL
    },
    instanceLoaded: {
      get() {
        return instanceLoaded.value
      },
      set(val) {
        instanceLoaded.value = val
      },
    },
    verificationDuring: {
      get() {
        return verificationDuring.value
      },
      set(val) {
        verificationDuring.value = val
      },
    },
    ftxIdentityLiteInstance: {
      get() {
        return ftxIdentityLiteInstance.value
      },
      set(val) {
        ftxIdentityLiteInstance.value = val
      },
    },
  },
  methods: {
    setHeaderHeight() {
      let locationHeight = 0
      if (document.querySelector('.q-header')) {
        if (this.$q.platform.is?.mobile)
          locationHeight = document.querySelector(
            '.q-header .h-location'
          ).clientHeight
        this.headerHeight = Math.round(
          document.querySelector('.q-header').clientHeight - locationHeight
        )
      }
    },
    initEAIVPopup(params, isStart = false) {
      this.ftxIdentityLiteInstance = new FTXIdentityLite(params)
      if (isStart) this.ftxIdentityLiteInstance.start()
      this.identityInstanceInitialized = true
      if (!isStart && params.hasOwnProperty('verificationDuring')) {
        this.verificationDuring = params.verificationDuring
      }
    },
    setIdentityInstance(val) {
      FTXIdentityLite = val
      this.instanceLoaded = true
    },
    resetVerification() {
      if (this.ftxIdentityLiteInstance)
        this.ftxIdentityLiteInstance.resetVerificationOnBack()
    },
    async identitySuccessHandler(sessionId) {
      let eaivSessionId =
          sessionId || this.persistedStore.eaivPersistedSessionId,
        routeName = this.$route.name,
        mismatchedFieldName = []
      this.ageVerificationStore.setLoading(true)

      this.ageVerificationStore
        .checkStatus(eaivSessionId)
        .then(async (response) => {
          this.ageVerificationStore.setLoading(false)
          if (response.success && response.data?.isVerified === true) {
            /* START: Make entry in verification history triggered with Age Gate */
            if (
              !this.$q.platform.is?.cordova &&
              sessionId &&
              sessionId != this.persistedStore.eaivPersistedSessionId
            ) {
              this.persistedStore.setField({
                field: 'eaivPersistedSessionId',
                value: sessionId,
              })
              await this.ageVerificationStore.verificationHistory({
                customerID: this.customer?.id || null,
                profileID: response.data.profileId,
                sessionID: sessionId,
                ageVerificationStatus: 1,
                verificationDuring: this.verificationDuring,
              })
            }
            /* END: Make entry in verification history triggered with Age Gate */

            let personalInfo = response.data?.personalInfo,
              preFillInformation = response.data?.preFillInformation

            if (
              (this.isLoggedIn ||
                (!this.isLoggedIn && routeName == 'Checkout')) &&
              personalInfo &&
              preFillInformation &&
              (personalInfo?.firstName != preFillInformation?.firstName ||
                personalInfo?.lastName != preFillInformation?.lastName ||
                isDateEqual(personalInfo?.dob, preFillInformation?.dob) ==
                  false)
            ) {
              if (personalInfo?.firstName != preFillInformation?.firstName)
                mismatchedFieldName.push('firstName')
              if (personalInfo?.lastName != preFillInformation?.lastName)
                mismatchedFieldName.push('lastName')
              if (
                isDateEqual(personalInfo?.dob, preFillInformation?.dob) == false
              )
                mismatchedFieldName.push('dob')

              this.changeDialogState({
                dialog: 'MismatchPersonalInfo',
                val: true,
                properties: {
                  personalInfo,
                  preFillInformation,
                  mismatchedFieldName,
                  onContinue: this.verificationComplete,
                  onCancel: this.onCancelVerification,
                },
              })
            } else {
              this.verificationComplete(eaivSessionId, routeName, true)
            }
          }
        })
        .catch(() => {
          this.ageVerificationStore.setLoading(false)
        })
    },
    async identityErrorHandler(sessionId) {
      let eaivSessionId =
          sessionId || this.persistedStore.eaivPersistedSessionId,
        routeName = this.$route.name,
        isTriggerFromAgeGate = false
      this.ageVerificationStore.setLoading(true)

      this.ageVerificationStore
        .checkStatus(eaivSessionId)
        .then(async (response) => {
          if (response.success && response.data?.isVerified === false) {
            /* START: Make entry in verification history triggered with Age Gate */
            if (
              !this.$q.platform.is?.cordova &&
              sessionId &&
              sessionId != this.persistedStore.eaivPersistedSessionId
            ) {
              isTriggerFromAgeGate = true
              this.persistedStore.setField({
                field: 'eaivPersistedSessionId',
                value: sessionId,
              })
              await this.ageVerificationStore.verificationHistory({
                customerID: this.customer?.id || null,
                profileID: response.data.profileId,
                sessionID: sessionId,
                ageVerificationStatus: 2,
                verificationDuring: this.verificationDuring,
              })
            }
            /* END: Make entry in verification history triggered with Age Gate */

            this.ageVerificationStore
              .verificationComplete({
                sessionId: eaivSessionId,
                params: { isInfoMismatched: false },
              })
              .then((response) => {
                this.ageVerificationStore.setLoading(false)
                this.ageVerificationStore.setVerificationStatus(false)
                this.persistedStore.setField({
                  field: 'eaivPersistedSessionId',
                  value: null,
                })
                removeAVSessionID()

                if (this.ageRestrictedPages.includes(routeName) === true) {
                  this.emitter.emit('eaivVerificationFailed', {
                    eaivSessionId: eaivSessionId,
                    routeName: this.$route.name,
                    isPopup: true,
                    isTriggerFromAgeGate: isTriggerFromAgeGate,
                  })
                } else {
                  tempCacheStorage.clear()
                  this.ageVerificationStore.setLoading(false)
                  if (!this.showEAIVPage || isTriggerFromAgeGate) {
                    this.changeDialogState({
                      dialog: 'VerificationFailDialog',
                      val: true,
                      properties: {
                        isTriggerFromAgeGate: isTriggerFromAgeGate,
                      },
                    })
                  }
                }
              })
              .catch(() => {
                this.ageVerificationStore.setLoading(false)
              })
          }
        })
        .catch(() => {
          this.ageVerificationStore.setLoading(false)
        })
    },
    verificationComplete(eaivSessionId, routeName, isSuccess = true) {
      tempCacheStorage.clear()
      this.ageVerificationStore.setLoading(true)
      this.ageVerificationStore
        .verificationComplete({
          sessionId: eaivSessionId,
          params: { isInfoMismatched: false },
        })
        .then((response) => {
          if (this.ageRestrictedPages.includes(routeName) === true) {
            setAVSessionID(eaivSessionId)
            this.emitter.emit('eaivVerificationSuccess', {
              eaivSessionId,
              routeName,
              isPopup: true,
            })
            this.persistedStore.setField({
              field: 'eaivPersistedVerificationSuccess',
              value: true,
            })
            this.ageVerificationStore.setVerificationStatus(true)

            if (this.isLoggedIn) {
              this.authStore.getUserInfo()
              this.customerStore.setCustomerDetails({
                ...this.customer,
                isVerifiedOnline: true,
              })
            }

            this.changeDialogState({
              dialog: 'MismatchPersonalInfo',
              val: false,
              properties: {},
            })
          } else {
            this.persistedStore.setField({
              field: 'eaivPersistedVerificationSuccess',
              value: true,
            })
            this.ageVerificationStore.setVerificationStatus(true)
            setAVSessionID(eaivSessionId)
            this.showSuccess('Age Verified Successfully.')
            this.ageVerificationStore.setLoading(false)

            if (this.isLoggedIn) {
              this.authStore.getUserInfo()
              this.customerStore.setCustomerDetails({
                ...this.customer,
                isVerifiedOnline: true,
              })
            }

            this.changeDialogState({
              dialog: 'MismatchPersonalInfo',
              val: false,
              properties: {},
            })
          }

          if (
            !this.isLoggedIn &&
            routeName != 'Checkout' &&
            this.businessConfigurations?.isStoreAgeRestricted &&
            this.businessConfigurations?.enableAgeRestrictedBrowsing
          )
            this.changeDialogState({
              dialog: 'AskForSignup',
              val: true,
              properties: {},
            })
        })
        .catch((err) => {
          this.ageVerificationStore.setLoading(false)
        })

      // Remove skip from persisted
      this.ageVerificationStore.setField({
        field: 'skipBrowsingAgeRestrictedProd',
        value: false,
      })
    },
    onCancelVerification(eaivSessionId) {
      this.ageVerificationStore
        .verificationComplete({
          sessionId: eaivSessionId,
          params: { isInfoMismatched: true },
        })
        .then((response) => {
          this.persistedStore.setField({
            field: 'eaivPersistedSessionId',
            value: null,
          })
          this.ageVerificationStore.resetVerificationStatus()
          this.changeDialogState({
            dialog: 'MismatchPersonalInfo',
            val: false,
            properties: {},
          })
        })
    },
    loadIdentityInstance(cb = null) {
      const _this = this
      let maxIntervalLimit = 20
      const stopInterval = () => {
        if (_this.interval) {
          clearInterval(_this.interval)
          _this.interval = null
        }
        maxIntervalLimit = 0
      }

      if (_this.interval) {
        clearInterval(_this.interval)
        _this.interval = null
      }

      _this.interval = setInterval(() => {
        maxIntervalLimit -= 1
        if ('FTXIdentityLite' in window) {
          _this.setIdentityInstance(window.FTXIdentityLite.default)
          stopInterval()
          if (cb) cb()
        } else if (maxIntervalLimit <= 0) stopInterval()
      }, 1000)
    },
  },
}
